import dejsonapinize from "./dejsonapinize";
export { dejsonapinize };

import diff from "./diff";
export { diff };

import toFormData from "./toFormData";
export { toFormData };

import logError from "lib/utils/errors/logError";
export { logError };

import handleError from "lib/utils/errors/handleError";
export { handleError };

export * from "./serializers";

export function findResponseErrorMessage(e) {
  if (e.response && e.response.data && e.response.data.errors) {
    return e.response.data.errors.map((e) => e.detail || e.code).join("; ");
  }

  return "Błąd podczas zapisu na serwerze.";
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/index.js